import http_request from './http_request'
import config from 'config'

function searchGoogleImages(searchText, page, headers = {}) {
	return http_request.get(config.api + 'google_images')
		.withHeaders(headers)
		.send({
			q: searchText,
			page,
		})
		.then(function(response) {
			return {
				error_code: response.error_code,
				message: response.message,
				payload: {
					data: response.payload.images.data,
					showMore: response.payload.images.showMore,
					hint: response.payload.images.hint,
				},
			}
		})
}

function searchBingImages(searchText, page, allowSearchMore) {
	return http_request.get(config.api + 'bing_images')
		.send({
			q: searchText,
			page,
			allowSearchMore,
		})
		.then(function(response) {
			return {
				error_code: response.error_code,
				message: response.message,
				payload: {
					data: response.payload.images.data,
					showMore: response.payload.images.showMore,
					hint: response.payload.images.hint,
				},
			}
		})
}

function searchGoogleGifs(searchText, page, allowSearchMore) {
	return http_request.get(config.api + 'google_gifs')
		.send({
			q: searchText,
			page,
			allowSearchMore,
		})
		.then(function(response) {
			return {
				error_code: response.error_code,
				message: response.message,
				payload: {
					data: response.payload.gifs.data,
					showMore: response.payload.gifs.showMore,
					hint: response.payload.gifs.hint,
				},
			}
		})
}

function searchYoutubeVideos(searchText, page) {
	return http_request.get(config.api + 'youtube_videos')
		.send({
			q: searchText,
			page,
		})
		.then(function(response) {
			return {
				error_code: response.error_code,
				message: response.message,
				payload: {
					data: response.payload.videos.data,
					showMore: response.payload.videos.showMore,
					hint: response.payload.videos.hint,
				},
			}
		})
}

function getYoutubeVideosDetails(ids) {
	return http_request.get(config.api + 'youtube_videos/details')
		.send({
			ids: ids.join(','),
		})
}

export default {
	searchGoogleImages,
	searchBingImages,
	searchGoogleGifs,
	searchYoutubeVideos,
	getYoutubeVideosDetails,
}
